export default "__VITE_ASSET__D$1l$5ly__"